import { Module, Mutation, VuexModule, Action } from 'vuex-class-modules'
import axios from 'axios'

@Module
class RestorationObjectModule extends VuexModule {
  collectionModule = null
  collectionItemModule = null
  dirty = false

  @Mutation
  setCollectionItemModule (collectionItemModule) {
    this.collectionItemModule = collectionItemModule
  }

  @Mutation
  setCollectionModule (collectionModule) {
    this.collectionModule = collectionModule
  }

  @Mutation
  setDirty (dirty) {
    this.dirty = dirty
  }

  @Action
  async createObjectPart (data) {
    let jsonpath = '/parts'
    if (this.collectionItemModule.item.metadata.parts) {
      jsonpath = `${jsonpath}/-`
    } else {
      data = [data]
    }

    const resp = await this.collectionItemModule.patch([{
      op: 'add',
      path: jsonpath,
      value: data
    }])
    await this.collectionItemModule.reload()
    return resp
  }

  @Action
  async createRestorationWork (data) {
    const worksUrl = this.collectionItemModule.item.links.works
    const resp = await axios.post(worksUrl, data)
    return resp
  }

  @Action
  async setObjectPartName (idx, name) {
    let jsonpath = `/parts/${idx}/name`
    if (typeof this.collectionItemModule.item.metadata.parts[idx] !== 'undefined') {
      const resp = await this.collectionItemModule.patch([{
        op: 'remove',
        path: jsonpath,
        value: name
      }])
      await this.collectionItemModule.reload()
      return resp
    }
  }

  @Action
  async removeObjectPart (idx) {
    let jsonpath = `/parts/${idx}`
    if (typeof this.collectionItemModule.item.metadata.parts[idx] !== 'undefined') {
      const resp = await this.collectionItemModule.patch([{
        op: 'remove',
        path: jsonpath
      }])
      await this.collectionItemModule.reload()
      return resp
    }
  }

  @Action
  async createRestorationObject (data) {
    const resp = await axios.post(this.collectionModule.restSearchUrl, data)
    await this.collectionItemModule.load(
      {
        collectionDefinition: this.collectionModule.collectionDefinition,
        itemId: resp.data.metadata.id,
        force: false
      })
    return resp.data
  }

  @Action
  async reloadIfNeeded () {
    if (this.dirty) {
      this.setDirty(false)
      this.collectionItemModule.reload()
    }
  }
}

export default RestorationObjectModule
